export const deletePhaseModalStyles = {
  modal: {
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      height: '48px',
      padding: 0,
      '& button': {
        margin: '0 12px',
      },
    },

    '& .MuiDialog-paper': {
      width: '420px',
      maxWidth: '420px',
      padding: '40px 40px 20px 40px',
      borderRadius: '12px',
      overflow: 'auto',
      backgroundColor: '#fff',
    },
  },

  titleContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    paddingBottom: '20px',
  },

  title: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
    marginBottom: '4px',
  },

  subtitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6E707A',
  },

  buttonsContainer: {
    width: '100%',
    paddingTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '12px',
  },

  cancelButton: {
    width: '70px',
    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    padding: '14px 12px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#4D6EF5',
    transition: '300ms',
    textTransform: 'none',

    '&:hover': {
      color: '#FFFFFF',
      background: '#4D6EF5',
      border: '1px solid #4D6EF5',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
  },

  saveButton: {
    background: '#4D6EF5',
    borderRadius: '8px',
    border: '1px solid #4D6EF5',
    padding: '14px 18px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#FFFFFF',
    transition: '300ms',
    textTransform: 'none',

    '&:hover': { color: '#4D6EF5', background: '#FFFFFF', border: '1px solid #4D6EF5' },
  },
};
